import { withModalProvider } from "../../hoc/withModalProvider";

import { FreeTextQuestionModal as View, IProps } from "./FreeTextQuestionModal";

export const FreeTextQuestionModal = withModalProvider<IProps>(View);
